import { mountAdditionalVueInstance } from '@/utils/init-vue-helpers';

mountAdditionalVueInstance({
  fn: () => import('@/features/custom-form-templates/custom-form-templates.vue'),
  htmlElementId: 'vue-app-patient-form-template-editor',
  customEventName:  'mountCustomPatientFormTemplateEditor',
  mountOnInitialPageLoad: true
})